import * as React from "react";
import PropTypes from "prop-types";

import { LOGO } from "const/images";

import ErrorStyles from "./error.style";

type ErrorLayoutProps = {
    statusCode: number;
    message: string;
    description: string;
    children?: React.ReactNode;
};

const ErrorLayout = ({
    statusCode,
    message,
    description,
    children
}: ErrorLayoutProps) => (
    <>
        <section className="grSection">
            <ErrorStyles />
            <div className="grContainer">
                <h1 className="grContainer__title">{statusCode}</h1>

                <h2 className="grContainer__title">{message}</h2>

                {description && (
                    <div className="grContainer__subtitle">
                        <h4 className="grContainer__subtitle-text">
                            {description}
                        </h4>
                    </div>
                )}

                {children}

                <div className="grContainer__cta">
                    <div className="grArrow"></div>
                    <a
                        href="/"
                        className="grContainer__cta--back js-previous-page"
                    >
                        Go Home
                    </a>
                </div>
            </div>

            <aside className="grAside">
                <img className="grAside__logo" src={LOGO} alt="Grabyo Logo" />
            </aside>
        </section>
        <footer className="grFooter">
            <a href="https://grabyo.com" className="grFooter__cta">
                Grabyo
            </a>
            <span className="grFooter__vh">|</span>
            <a
                href="https://about.grabyo.com/about-us/"
                className="grFooter__cta"
            >
                About
            </a>
            <span className="grFooter__vh">|</span>
            <a
                href="https://about.grabyo.com/terms-of-service/"
                className="grFooter__cta"
            >
                Terms
            </a>
        </footer>
    </>
);

ErrorLayout.propTypes = {
    statusCode: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    description: PropTypes.string
};

ErrorLayout.defaultProps = {
    statusCode: 500,
    message: `Whoops`,
    description: `Something went wrong`
};

export default ErrorLayout;
